// extracted by mini-css-extract-plugin
module.exports = {"deleteWindow":"DeleteConfirmation_deleteWindow__3lIKJ","deleteTitle":"DeleteConfirmation_deleteTitle__1ImaH","form":"DeleteConfirmation_form__zQ0y8"};